import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseResult } from 'src/app/models-classes/common.model';
import { InterceptorSkipHeader } from 'src/app/shared/constants/global-variable.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  api_url = environment.api.baseUrl;
  headers = new HttpHeaders().set(InterceptorSkipHeader, '').set('langid', localStorage.getItem('current_lang') == 'en' ? '2' : '1');

  constructor(private _http: HttpClient) { }

  //CalculateSendReceivePrice
  calculateSendReceivePrice(senderLatLng: string, receiverLatLng: string, carSizeId: number): Observable<ResponseResult> {
    return this._http.get<ResponseResult>(`${this.api_url}/Customer/CalculateSendReceivePrice?senderLatLng=${senderLatLng}&receiverLatLng=${receiverLatLng}&carSizeId=${carSizeId}`);
  }
  //CreateSendReceiveOrder
  createOrder(order: any): Observable<ResponseResult> {
    return this._http.post<ResponseResult>(`${this.api_url}/Customer/CreateSendReceiveOrder`, order);
  }

  //CreateBatchSendReceiveOrders
  createBatchOrder(object: any): Observable<ResponseResult> {
    return this._http.post<ResponseResult>(`${this.api_url}/Customer/CreateBatchSendReceiveOrders`, object);
  }

  //CalculateBatchSendReceivePrices post by send /*
  // [
  // {
  //   "senderLatLng": "string",
  //   "receiverLatLng": "string",
  //   "carSizeId": 0
  // }
  // ]
  //  */
  calculateBatchSendReceivePrices(object: any): Observable<ResponseResult> {
    return this._http.post<ResponseResult>(`${this.api_url}/Customer/CalculateBatchSendReceivePrices`, object);
  }
}
